module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _h('div', {
    class: {
      slide: true, 'slide-enter': _vm.show, 'slide-leave': !_vm.show
    },
    attrs: {
      "id": "project-info"
    }
  }, [_h('div', {
    attrs: {
      "id": "info"
    }
  }, [_h('p', ["Want to learn how to build this Vue.js app?"]), " ", _vm._m(0), " ", _h('p', ["Leave your email address and we'll send you more info!"]), " ", _h('form', {
    attrs: {
      "action": "//getjsdojo.us13.list-manage.com/subscribe/post?u=cd0e0c3fe7829518b809554a8&id=ae2f1465e2",
      "method": "post",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    },
    on: {
      "submit": _vm.clearEmail
    }
  }, [_h('div', {
    staticClass: "inputs"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "Email address"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), " ", _h('input', {
    attrs: {
      "type": "hidden",
      "name": "COURSE",
      "value": "0"
    }
  }), " ", _h('input', {
    attrs: {
      "type": "hidden",
      "name": "SOURCE",
      "value": "proj_pos"
    }
  }), " ", _h('input', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "value": "Tell me more",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })]), " ", _vm._m(1)])]), " ", _h('div', {
    attrs: {
      "id": "tab"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, ["Learn To Build Me!\n        ", (_vm.show) ? _h('svg', {
    staticStyle: {
      "enable-background": "new 0 0 284.929 284.929"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "10px",
      "height": "10px",
      "viewBox": "0 0 284.929 284.929",
      "xml:space": "preserve"
    }
  }, [_h('g', [_h('path', {
    attrs: {
      "d": "M282.082,195.285L149.028,62.24c-1.901-1.903-4.088-2.856-6.562-2.856s-4.665,0.953-6.567,2.856L2.856,195.285 C0.95,197.191,0,199.378,0,201.853c0,2.474,0.953,4.664,2.856,6.566l14.272,14.271c1.903,1.903,4.093,2.854,6.567,2.854 c2.474,0,4.664-0.951,6.567-2.854l112.204-112.202l112.208,112.209c1.902,1.903,4.093,2.848,6.563,2.848 c2.478,0,4.668-0.951,6.57-2.848l14.274-14.277c1.902-1.902,2.847-4.093,2.847-6.566 C284.929,199.378,283.984,197.188,282.082,195.285z"
    }
  })])]) : _h('svg', {
    staticStyle: {
      "enable-background": "new 0 0 284.929 284.929"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "10px",
      "height": "10px",
      "viewBox": "0 0 284.929 284.929",
      "xml:space": "preserve"
    }
  }, [_h('g', [_h('path', {
    attrs: {
      "d": "M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441 L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082 c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647 c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"
    }
  })])]), " "])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _h('p', ["This app is one of three projects you'll build in the ", _h('strong', ["Ultimate Vue.js\n            Developers"]), " course."])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _h('div', [_h('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_h('input', {
    attrs: {
      "type": "text",
      "name": "b_cd0e0c3fe7829518b809554a8_607f131620",
      "tabindex": "-1",
      "value": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6aa96c5f!./~/vue-loader/lib/selector.js?type=template&index=0!./project_info/ProjectInfo.vue
// module id = 6
// module chunks = 0